export default __webpack_public_path__ + "static/media/blue-idcard.65c06c8c.png";